import { Link } from "react-router-dom";
import { usePortals } from "../hooks/usePortals";
import styles from "./Workflows.module.css";

export default function Workflows() {
  const portals = usePortals();

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Workflows</h1>
        <p className={styles.subtitle}>
          Pick a portal to open its workflow canvas.
        </p>
      </header>

      {portals.length === 0 && (
        <div className={styles.empty}>No connected portals yet.</div>
      )}

      <div className={styles.grid}>
        {portals.map((p) => (
          <Link
            key={p.id}
            to={`/tools/workflows/${p.id}`}
            className={styles.card}
          >
            <span className={styles.cardName}>
              {p.nickname ?? p.name ?? p.id}
            </span>
            {p.hubDomain && (
              <span className={styles.cardDomain}>{p.hubDomain}</span>
            )}
            <span className={styles.cardId}>Portal {p.id}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
